var moment = require('moment');

var EmployeeDropDownView = require('../../../shared/app/views/components/employee-selector');
var GuestsSelectorView = require('../../../shared/app/views/components/guests-selector');
var MultipleGuestView = require('../multiple-guest/multiple-guest');
var MapSelectorModel = require('../../models/start-wait-list/map-selector');

var ClientFormView = require('./client-form');
var requestsManager = require('../../../shared/app-mobile/managers/requests-manager');
var Leaflet = require('../../../shared/map-service');
var geolib = require('geolib');
var locationService = require('../../../shared/location-service');

const { checkinLaterState } = require('../../../shared/managers/checkin-later-manager');

var requestsManagerKeys = {
  GET_STORE_WAIT_TIMES: 'getStoreWaitTimes',
  GET_GEO_IP: 'getGeoIp',
  GET_STORE_LOCATION: 'getStoreLocation',
  GET_SERVICE_PROVIDERS: 'getServiceProviders',
  SEARCH_NEAREST_OPEN_STORES: 'searchNearestOpenStores',
  WAIT_LIST_SEARCH: 'waitListSearch'
};

var MapSelectorView = Backbone.Epoxy.View.extend({

  template: 'start-wait-list.mapContainer',
  bindings: 'data-bind',

  MIN_ZOOM_LEVEL: 9,
  MAX_Z_INDEX: 1000000,
  DEFAULT_ZOOM_LEVEL: 12,
  recomputeZoomAfterChangeLocation: false,
  DEFAULT_LOCATION: locationService.getDefaultLocation(),
  UPDATE_WAIT_TIMES_COOLDOWN: 60000, //TODO:: make it tunable
  STORE_PER_BATCH: 9999, //TODO:: make it tunable

  events: {
    'click .booking-button': 'proceedToBooking',
    'keydown .booking-button': 'proceedToBooking',
    'click .add-guest-button': 'addGuest',
    'click .store-rating-container': 'toggleStoreReviewPopup',
    'keydown .store-rating-container': 'toggleStoreReviewPopup',
    'click .checkin-later-button': 'proceedCheckInLater',
    'keydown .checkin-later-button': 'proceedCheckInLater',
    'click .what-is-checkin-later-button': 'onWhatIsCheckinLater',
    'keydown .what-is-checkin-later-button': 'onWhatIsCheckinLater',
  },

  disposeWaitTimesTimeout: false,
  currentWaitTimesTimeout: null,

  initialize: function() {
    this.map = null;
    this.centerPositionVersion = 0;
    this.markersMap = {};
    this.storesMap = {};
    this.selectedStoreId = null;
    this.userPosition = null;
    this.defaultZoom = null;
    this.shouldRecomputeNextZoom = false;
    this.ignoreUserPosition = false;
    this.ignoreUpdateShownMarker = false;

    this.model = new MapSelectorModel();
    this.model.set('service',
      bookedby.app.serviceManager.serviceMap[bookedby.staticData.storeGroupSettings.defaultCentralService]);

    this.guestNumberComponent = new GuestsSelectorView({
      model: this.model.get('guests'),
      boundProperty: 'numberOfGuests'
    });

    this.clientInfoComponent = new ClientFormView();
    this.clientInfoComponent.guestNumberComponent = this.guestNumberComponent;

    this.guestsComponent = new MultipleGuestView({
      model: this.model.get('guests'),
      requireGuests: _.bind(function() { return this.model.get('iAmOnlyCheckingInAGuest'); }, this)
    });

    this.employeeComponent = new EmployeeDropDownView({
      model: this.model,
      boundProperty: 'provider',
      serviceProperty: 'service',
      referenceContainer: '#appointmentModal'
    });

    this.model.on('change:iAmOnlyCheckingInAGuest', _.bind(function(model, value) {
      if (value) {
        if (this.model.get('guests').get('numberOfGuests') < 1) {
          this.addGuest();
        } else {
          this.loadEmployeesWaitTimes();
        }
      } else {
        this.loadEmployeesWaitTimes();
      }
    }, this));

    this.employeeComponent.matchWithServices = true;
    this.employeeComponent.filterByWaitListAvailability = bookedby.staticData.storeGroupSettings.useWaitingList; //TODO consider both usages
    this.employeeComponent.showFirstAvailablePlaceholder = true;

    this.signupPromptModel = bookedby.app.signupPromptForm.model;
    this.signupPromptForm = bookedby.app.signupPromptForm;

    this.hasRendered = false;

    this.disposeWaitTimesTimeout = false;

    //update visible stores from time to time
    this.getUpdatedStoreWaitTimes(); //TODO restore ?

    $.event.special.heightChanged = {
      remove: function() {
        $(this).children('iframe.height-changed').remove();
      },
      add: function () {
        var elm = $(this);
        var iframe = elm.children('iframe.height-changed');
        if (!iframe.length) {
          iframe = $('<iframe/>').addClass('height-changed').css({
            height: '100%',
            display: 'block',
            border: 0,
            width: 0,
            margin: 0,
            float: 'left'
          }).prependTo(this);
        }
        var oldHeight = elm.height();
        function elmResized() {
          var height = elm.height();
          if (oldHeight != height) {
            elm.trigger('heightChanged', [height, oldHeight]);
            oldHeight = height;
          }
        }

        var timer = 0;
        var ielm = iframe[0];
        (ielm.contentWindow || ielm).onresize = function() {
          clearTimeout(timer);
          timer = setTimeout(elmResized, 20);
        };
      }
    };
  },

  toggleStoreReviewPopup: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          var store = this.storesMap[this.model.get('selectedStore')];
          bookedby.app.storeReviewsPopup.show({
              id: store.id,
              name: store.name,
              avgRating: store.rating,
              numRatings: store.numReviews,
              photoId: store.photoId
          });
      }
  },

  getJsonForWaitlistBooking: function() {

    var servicesInfo = [{
      service: this.model.get('service').get('id'),
      employee: this.model.get('provider') != null ? this.model.get('provider').get('id') : null
    }];

    var recentEstimative = this.model.get('estimatedTime') == null ? 0 : this.model.get('estimatedTime');

    var output = {
      store: this.selectedStoreId,
      storeGroupUuid: bookedby.staticData.storeGroupId,
      recentEstimative: recentEstimative,
      cardUuid: bookedby.app.getCurrentClient().get('cardUuid'),
      source: 'web'
    };

    var guestsServiceInfo = this.model.get('guests').get('serviceProviders').map(function(guest) {
      return {
        service: guest.get('service').id,
        employee: guest.get('provider') ? guest.get('provider').id : null,
        recentEstimative: guest.get('estimatedWaitTime'),
        client: {
          firstName: guest.get('firstName'),
          lastName: guest.get('lastName')
        }
      }
    });

    output.client = bookedby.app.getCurrentClient().toJSON();
    output.client.phone1 = output.client.phone;
    output.services = servicesInfo;
    output.iAmOnlyCheckingInAGuest = this.model.get('iAmOnlyCheckingInAGuest');
    output.asGuest = !bookedby.app.getCurrentClient().get('loggedIn');
    output.guests = guestsServiceInfo;

    return output;
  },

  completeWaitListBooking: function(data, checkInData) {
    if (data.success) {
      if (data.didBook) {
        bookedby.app.ignoreNextBooking = true;
        global.bookedby.helpers.checkInEvent('checkin', data.storeShortName || "StoreId" + this.selectedStoreId);

        if (!bookedby.app.getCurrentClient().get('loggedIn')) {
          bookedby.app.navigateTo('guest-appointment', {
            uuid: data.uuid
          });
        } else {
          bookedby.app.navigateTo('waiting-list');
        }
      } else {
        if (data.reasonCode) {
          if (data.reasonCode == 'estimationChanged') {

            //this.bookingFormModel.set('totalEstimatedTime', data.newEstimative);
            var newEstimative = data.newEstimative * 60;
            var newWaitTimes = data.newWaitTimes;
            this.model.set('estimatedTime', newEstimative);
            this.dataVersion++;
            //this.bookingFormView.render();
            var newEstimatedTimeString = bookedby.helpers.timeToDuration(newEstimative).fullTime;

            var errorCheckingNewWaitTimes = function(finishLoading, error) {
              error = error || 'There is an error with rechecking guests wait times, please try to check-in again later';
              finishLoading();
              bookedby.app.confirmForm.show(_.noop, _.noop, {
                message: error,
                confirmLabel: 'Ok',
                showCancelLabel: false
              });
            };

            var confirm = _.bind(function(finishLoading) {
              checkInData = checkInData || this.getJsonForWaitlistBooking();
              if (checkInData){
                //Trying to book again with new estimation
                if (newWaitTimes != null) {
                  //New style per-guest new estimates
                  if (newWaitTimes[0] != null && newWaitTimes[0] != -99) {
                    checkInData.recentEstimative = newWaitTimes[0] * 60;
                  }
                } else {
                  //Old style single estimate kept in case client (desktop) not updated
                  checkInData.recentEstimative = newEstimative;
                }
                if (checkInData.guests && checkInData.guests.length) {
                  var guestOffset = checkInData.iAmOnlyCheckingInAGuest ? 0 : 1;
                  if (newWaitTimes != null && newWaitTimes.length >= checkInData.guests.length + guestOffset) {
                    for (var i = 0; i < checkInData.guests.length; i++) {
                      checkInData.guests[i].recentEstimative = newWaitTimes[i + guestOffset] * 60;
                    }
                    this.tryBookWaitingList(false, checkInData, finishLoading);
                  } else {
                    if (checkInData.iAmOnlyCheckingInAGuest && checkInData.guests.length == 1){
                      checkInData.guests[0].recentEstimative = newEstimative;
                      this.tryBookWaitingList(false, checkInData, finishLoading);
                    } else {
                      this.setGuestsWaitingTimes(checkInData).then(_.bind(function(result) {
                        if (result.success){
                          this.tryBookWaitingList(false, checkInData, finishLoading);
                        } else {
                          errorCheckingNewWaitTimes(finishLoading, result.error);
                        }
                      },this), _.bind(errorCheckingNewWaitTimes,this, finishLoading));
                    }
                  }
                } else {
                  this.tryBookWaitingList(false, checkInData, finishLoading);
                }
              } else {
                this.tryBookWaitingList(false, null, finishLoading);
              }
            }, this);

            bookedby.app.confirmForm.show(confirm, _.noop, {
              message: 'The estimated wait time has changed to ' + newEstimatedTimeString + ' Still want to proceed?',
              cancelLabel: 'No',
              confirmLabel: 'Yes',
              showCancelLabel: true,
              useLoading: true,
              loadingLabel: 'Checking-in...'
            });
          } else if (data.reasonCode == 'alreadyInWaitList') {
            confirm = function() {
              if (!bookedby.app.getCurrentClient().get('loggedIn')) {
                bookedby.app.navigateTo('guest-appointment', {
                  uuid: data.waitListUuid
                });
              } else {
                bookedby.app.navigateTo('waiting-list');
              }
            };
            bookedby.app.confirmForm.show(confirm, _.noop, {
              message: 'You are already in a waiting list for today. Want to go to the managing page?',
              cancelLabel: 'Cancel',
              confirmLabel: 'Yes',
              showCancelLabel: true
            });
          } else if (data.reasonCode == 'emailIsRegistered') {
            this.showUserRegisteredPopup();
          } else if (data.reasonCode == 'unavailability') {
            var options = {
              cancelLabel: '',
              confirmLabel: 'Ok',
              showCancelLabel: false,
              message: data.reason
            };

            bookedby.app.confirmForm.show(_.noop, _.noop, options);
          }
        } else {
          alert('error'); //TODO better approach
        }
      }
    } else {
      //TODO:: is there a good way to allow the user to hit "back" on error and come back to the form?
      // Also can we get a "retry" or something in the page itself?
      bookedby.app.logAPIError(data.error);
      this.state = 'error';
      this.render();
    }
  },

  showUserRegisteredPopup: function() {
    var self = this;

    if (bookedby.app.currentClient.get("email") != null &&
        this.clientInfoComponent.registrationModel &&
        this.clientInfoComponent.registrationModel.get("email") != null) {
      bookedby.app.currentClient.set("email", this.clientInfoComponent.registrationModel.get("email"));
    }

    bookedby.app.confirmForm.show(function() {
      bookedby.app.showLogin('', function() {
        self.clientInfoComponent.render();
        self.tryBookWaitingList(false);
      });
    }, _.noop, {
      title: 'User is registered',
      message: 'A user with this data is already registered. Do you want to login?',
      confirmLabel: 'Login',
      cancelLabel: 'Cancel',
      showCancelLabel: true,
      allowClose: false
    })
  },

  tryBookWaitingList: function(justPrompt, bookingData, finishLoading) {
    finishLoading = finishLoading || _.noop;

    var options = {
      message: '',
      cancelLabel: '',
      confirmLabel: 'Ok',
      showCancelLabel: false
    };

    /**
     * Validate guests if they exists
     */

    // Parse variables;
    var clientModel;
    if (this.clientInfoComponent.showLogin) {
      clientModel = bookedby.app.getCurrentClient();
    } else {
      clientModel = this.clientInfoComponent.registrationModel;
    }

    this.model.get('guests').parseGuestsName();

    var allGuestsValid = this.model.get('guests').allGuestsValid();

    clientModel.set('isGuest', true);
    clientModel.isValid(true); //toggle validation errors
    var isValid = false;
    if(!clientModel.get('loggedIn') && this.clientInfoComponent.showLogin) {
      // NOTE: validate login form
      isValid = clientModel.isValid(['email', 'password']);
    } else if(!clientModel.get('loggedIn')) {
      // NOTE: validate registration form
      isValid = clientModel.isValid(['firstName', 'lastName', 'phone', 'zipCode', 'email', 'birthday', 'over13']);
    } else {
      // NOTE: omit logged user validation
      isValid = true
    }

    if (!isValid || !allGuestsValid) {
      finishLoading();
      return;
    }


    if(!clientModel.get('loggedIn') && this.clientInfoComponent.showLogin) {
      bookedby.app.loginClient(clientModel.get('email'), clientModel.get('password'),
        _.bind(function() {
          global.bookedby.helpers.checkInEvent('login');
          this.tryBookWaitingList(false, bookingData, finishLoading);
        }, this),
        _.bind(function(data) {
          finishLoading();
          options.message = data.error;
          bookedby.app.confirmForm.show(_.noop, _.noop, options);
        }, this)
      );
      return;
    }

    if (justPrompt && !clientModel.get('loggedIn')) {
      this.model.set('isSubmitting', true);
      this.model.set('isFullyLoaded', false);
      bookedby.app.checkClientIsRegistered(_.bind(this.onCheckResponse, this), clientModel);
      return;
    }

    var data = bookingData? bookingData: this.getJsonForWaitlistBooking();

    //return; //TODO for debug

    this.model.set('isSubmitting', true);

    $.ajax({
      url: bookedby.routes.BOOKING.BOOK_WAIT_LIST,
      contentType: 'application/json',
      data: JSON.stringify(data),
      method: 'POST',
      dataType: 'json',
      success: _.bind(function(data) {
        if (!data.success && data.userError) {
          if  (data.error == 'Card Required') {
            //this.showCardPopup(); //TODO
            alert('card required');
          } else if (data.error == 'User is not signed in') {
            alert('user not signed in');
          } else if (data.error == 'Email is registered') {
            //his.showUserRegisteredPopup(); //TODO
            alert('user registered');

          } else {
            options.message = data.error;
            bookedby.app.confirmForm.show(function() {}, function() {}, options);
          }
        } else if (!data.success) {
          bookedby.app.logAPIError(data.error);

          if (data.errorType == 'noAuthentication') {
            bookedby.app.logOut(); // force logout in this session
            options.message = 'Please log in again in order to book the appointment';
            bookedby.app.confirmForm.show(function() {}, function() {}, options);
          } else {
            options.message = data.error;
            bookedby.app.confirmForm.show(function() {}, function() {}, options);
          }
        } else {
          //Finish loading early, to prevent issues with "confirm dialog loop" - if a second dialog is opened this closes it, so it should close before re-opening
          finishLoading();
          finishLoading = _.noop;
          this.completeWaitListBooking(data);
        }
      }, this),
      error: _.bind(function(jqXHR, textStatus, textError) {
        bookedby.app.logAPIError(textError);
        this.state = 'error';
        this.render();
      }, this)
    }).always(_.bind(function() {
      finishLoading();
      this.model.set('isSubmitting', false);
    }, this));
  },

  tryCheckinLater: function(justPrompt, bookingData, finishLoading) {
    finishLoading = finishLoading || _.noop;

    var options = {
      message: '',
      cancelLabel: '',
      confirmLabel: 'Ok',
      showCancelLabel: false
    };

    /**
     * Validate guests if they exists
     */

      // Parse variables;
    var clientModel;
    if (this.clientInfoComponent.showLogin) {
      clientModel = bookedby.app.getCurrentClient();
    } else {
      clientModel = this.clientInfoComponent.registrationModel;
    }

    this.model.get('guests').parseGuestsName();

    var allGuestsValid = this.model.get('guests').allGuestsValid();

    clientModel.set('isGuest', true);
    clientModel.isValid(true); //toggle validation errors
    var isValid = false;
    if(!clientModel.get('loggedIn') && this.clientInfoComponent.showLogin) {
      // NOTE: validate login form
      isValid = clientModel.isValid(['email', 'password']);
    } else if(!clientModel.get('loggedIn')) {
      // NOTE: validate registration form
      isValid = clientModel.isValid(['firstName', 'lastName', 'phone', 'zipCode', 'email', 'birthday', 'over13']);
    } else {
      // NOTE: omit logged user validation
      isValid = true
    }

    if (!isValid || !allGuestsValid) {
      finishLoading();
      return;
    }


    if(!clientModel.get('loggedIn') && this.clientInfoComponent.showLogin) {
      bookedby.app.loginClient(clientModel.get('email'), clientModel.get('password'),
        _.bind(function() {
          this.tryCheckinLater(false, bookingData, finishLoading);
        }, this),
        _.bind(function(data) {
          finishLoading();
          options.message = data.error;
          bookedby.app.confirmForm.show(_.noop, _.noop, options);
        }, this)
      );
      return;
    }

    if (justPrompt && !clientModel.get('loggedIn')) {
      this.model.set('isSubmitting', true);
      this.model.set('isFullyLoaded', false);
      bookedby.app.checkClientIsRegistered(_.bind(this.onCheckResponse, this), clientModel);
      return;
    }

    var checkinData = bookingData? bookingData: this.getJsonForWaitlistBooking();

    var params = this.getWaitListRequestData();
    var ajaxObject = {
      url: bookedby.routes.BOOKING.CHECK_IN_LATER_TIMESPANS,
      contentType: 'application/json',
      data: JSON.stringify({
        store: params.store,
        storeGroupUuid: params.storeGroupUuid
      }),
      method: 'POST',
      dataType: 'json',
      cache: false
    };

    var success = _.bind(function(data) {
      if (data.success) {
        this.model.set(
          "availableSlots",
          data.value.availableTimeStamps.map(function (it) {
            return {
              value: it,
              label: moment().clone().startOf("day").add(it, "seconds").format("h:mm A"),
            };
          })
        );
      }
      var availableSlots = this.model.get('availableSlots')

      if (availableSlots.length !== 0) {
        bookedby.app.showCheckInLater({step: 1, checkinData: checkinData, availableSlots: availableSlots});
      } else {
        options.message = "We're sorry but there is no availability at this moment. Please try again in another time.";
        bookedby.app.confirmForm.show(_.noop, _.noop, options);
      }
    }, this);

    requestsManager.newRequest("availableSlots", ajaxObject, true).then(success);
  },

  sendConfirmationCode: function (confirmationType, client) {
    var deferred = $.Deferred();

    var clientData = client.getConfirmationClientData();
    var checkinData = this.getJsonForWaitlistBooking();
    var waitTimeData = {
      estimatedServiceTime: this.storesMap[this.selectedStoreId].estimatedWaitTime,
      estimatedAt: this.storesMap[this.selectedStoreId].currentTime
    }

    bookedby.app.sendConfirmation(confirmationType, clientData, checkinData, waitTimeData
      ).then(_.bind(function(response) {
      client.set({
        sendConfirmCodeError: false
      });
      if (response.success) {
        deferred.resolve()
      } else {
        if (response.errCode === 400) {
          client.set({
            sendConfirmCodeError:true,
            sendConfirmCodeErrorMessage: response.clientValidationErrors
          });
          deferred.reject();
        } else if (response.userError){
          client.set({
            sendConfirmCodeError:true,
            sendConfirmCodeErrorMessage: response.error
          });
          deferred.reject();
          if (response.errCode == 'emailIsRegistered'){
            this.showUserRegisteredPopup();
          }
        } else {
          bookedby.app.confirmForm.show(_.bind(function() {
            this.sendConfirmationCode(confirmationType, client).then(deferred.resolve, deferred.reject);
          }, this), deferred.reject, {
            message: 'There was error sending confirmation code',
            cancelLabel: 'Cancel',
            confirmLabel: 'Try again',
            showCancelLabel: true
          });
        }
      }
    }, this));

    return deferred;
  },

  registationCodeEmmited: function(regCode, hasCheckin) {
    this.signupPromptForm.show(_.bind(
      function(client, checkinData, checkinResult){
        bookedby.staticData.regCode = null;
        bookedby.staticData.hasCheckin = null;

        bookedby.app.currentClient.set('phone1', bookedby.app.currentClient.get('phone'));
        if (checkinResult){

          if (this.signupPromptModel.get('accepted')) {
            if (this.signupPromptModel.get('valid')) {
              bookedby.app.currentClient.set('isGuest', false);
              this.completeWaitListBooking(checkinResult, checkinData);
            } else {
              if (this.signupPromptModel.get('errorCode') == 'emailIsRegistered')
                this.showUserRegisteredPopup();
              else {
                bookedby.app.confirmForm.show(function() {}, function() {},
                {
                  title: '',
                  message: this.signupPromptModel.get('errorMessage'),
                  cancelLabel: '',
                  confirmLabel: 'Ok',
                  showCancelLabel: false,
                  allowClose: true
                });
            }
          }
        } else {
          bookedby.app.currentClient.set('isGuest', true);
          this.completeWaitListBooking(checkinResult, checkinData);
        }

      } else {
        bookedby.app.navigateTo('profile');
      }
    }, this), regCode, hasCheckin);
  },

  onCheckResponse: function(data, clientModel) {
    this.model.set('isSubmitting', false);
    this.model.set('isFullyLoaded', true);
    if (data.success) {
      if (data.found == true) {
        this.showUserRegisteredPopup();
        return;
      }

      var options = {
        confirmLabel: 'Got It',
        showCancelLabel: false,
        title: "Registration confirmation succesfully sent",
        allowClose: false
      };

      var _sendConfirmation = _.bind(
        function(confirmationType, confirmationMessage, finishLoading){
          this.sendConfirmationCode(confirmationType, clientModel).then(_.bind(function() {
            finishLoading();
            options.message = confirmationMessage;
            //Cleanup model
            if (this.clientInfoComponent.registrationModel) {
              this.clientInfoComponent.registrationModel.tryClearData();
            }
            bookedby.app.confirmForm.show(_.bind(this.resetStoreSelection, this), _.noop, options);
          }, this));
        }
        ,this);

      //We have setting that limits sending confirmation to only Email
      if (bookedby.staticData.storeGroupSettings.disableRegistrationConfirmationSms){
        this.model.set('isSubmitting', true);
        this.model.set('isFullyLoaded', false);
        _sendConfirmation("Email", "Please check your mailbox for confirmation email and use the link inside to finish your registration and check-in",
        _.bind(function(){
          this.model.set('isSubmitting', false);
          this.model.set('isFullyLoaded', true);
        },this));
      } else {
        bookedby.app.confirmForm.show(
          function(finishLoading) {
            //Email Chosen
            _sendConfirmation("Email", "Please check your mailbox for confirmation email and use the link inside to finish your registration and check-in", finishLoading);
          },
          function(finishLoading) {
            //SMS chosen
            _sendConfirmation("SMS", "Please check your phone for new SMS and use the link inside to finish your registration and check-in", finishLoading);
          },
        {
          title: 'ACCOUNT VERIFICATION',
          message: 'In order to secure your account, we will send you a verification link to your preferred method below',
          cancelLabel: 'BY SMS',
          confirmLabel: 'BY EMAIL',
          loadingLabel: 'Emailing...',
          cancellingLabel: 'Sending SMS...',
          showCancelLabel: true,
          allowClose: true,
          showContactUs: bookedby.staticData.storeGroupSettings.isSCMode,
          useSameButtons: true,
          useLoading: true
        });
      }
    }
  },

  addGuest: function(e) {
    this.model.get('guests').set('numberOfGuests', this.model.get('guests').get('numberOfGuests') + 1);
    global.bookedby.helpers.addGuestEvent(this.model.get('guests').get('numberOfGuests'));
  },

  proceedToBooking: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          var params = {
              store: this.model.get('selectedStore')
          };

          this.tryBookWaitingList(true);
          return;

          var guestsValid = this.model.get('guests').allGuestsValid();
          if (!guestsValid) {
              return;
          }

          var servicesString = '' + this.model.get('service').get('id');
          if (this.model.get('provider') != null) {
              servicesString += '-' + this.model.get('provider').get('id');
          }
          params.services = servicesString;

          if (bookedby.staticData.storeGroupSettings.allowMultipleGuestBooking) {
              var guestsSearchString = this.model.get('guests').computeGuestSearch();
              if (guestsSearchString.length > 0) {
                  params.guestServices = guestsSearchString.join('_');
              }
          }

          var guestInfo = this.model.get('guests').getFullGuestInfo();
          bookedby.app.appointmentManager.setGuestsInfo(guestInfo);
          params.guestInfo = guestInfo;
      }
  },

  proceedCheckInLater: function(e) {
    if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
      this.tryCheckinLater();
    }
  },

  onWhatIsCheckinLater: function(e) {
    if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
      bookedby.app.showCheckInLater({ step: 4 });
    }
  },

  initMap: function () {
    this.map =  new Leaflet.mapbox.map('map', null, {
      center: this.DEFAULT_LOCATION,
      zoom: this.DEFAULT_ZOOM_LEVEL,
      minZoom: this.MIN_ZOOM_LEVEL,
      doubleClickZoom: false,
      trackResize: true,
    });

    var styleLayer = Leaflet.mapbox.styleLayer('mapbox://styles/mapbox/streets-v11');
    styleLayer.addTo(this.map);

    this.map.setMaxZoom(18);
    this.map.zoomControl.setPosition('topright');

    styleLayer.on('load', function () {
      if ($('.attribution-list').length !== 0) {
        return;
      }

      var attributions = $('.leaflet-control-attribution > a');
      $('.leaflet-control-attribution').empty();

      $('.leaflet-control-attribution').append('<ul class="attribution-list"></ul>');
      var list = $('.attribution-list');

      if (attributions.length >= 3) {
        for (var i = 0; i < 3; i++) {
          var attr = attributions[i];
          var item = '<li class="attribution-list-item"><a class=' + (i === 2 ? "is-bold" : "") + ' target="_blank" href="' + attr.toString() + '">' + $(attr).html() + '</a></li>';
          list.append(item);
        }
      }
    });

    this.markersMap = {};
    this.storesMap = {};

    this.initOneTimeEvents();

    var map = this.map;

    $(".leaflet-control-zoom-in").bind('keydown', function (e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        map.setZoom(map.getZoom() + 1);
      }
    });
    $(".leaflet-control-zoom-out").bind('keydown', function (e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        map.setZoom(map.getZoom() - 1);
      }
    });

    $('.leaflet-bottom.leaflet-left').append("<span id=\"mapbox-logo-description\" class=\"visually-hidden\">Mapbox logo</span>");
    $('.mapbox-logo').attr('aria-describedby', 'mapbox-logo-description');
  },

  initOneTimeEvents: function() {
    if (this.disposeWaitTimesTimeout) {
      this.disposeWaitTimesTimeout = false;
      this.getUpdatedStoreWaitTimes();
    }

    this.setDefaultZoom();
    this.goUserPosition();
  },

  setDefaultZoom: function() {
    this.defaultZoom = this.map.getZoom();
  },

  goUserPosition: function() {
    //Always load close stores for default location
    var deferred = this.loadCloseStores(true);
    if (!this.ignoreUserPosition){
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(_.bind(function(position) {
          this.setUserPosition(position.coords.latitude, position.coords.longitude);
          this.setCenter(position.coords.latitude, position.coords.longitude);
        }, this), _.bind(function(error) {
          console.log(error);
          deferred = $.Deferred();
          this.trySetCoordsByIp().then(_.bind(function(){this.loadCloseStores(true).then(function(){deferred.resolve();})}, this));
        }, this));
      } else {
        deferred = $.Deferred();
        this.trySetCoordsByIp().then(_.bind(function(){this.loadCloseStores(true).then(function(){deferred.resolve();})}, this));
      }
    }
    deferred.then(_.bind(function(){
      this.trigger('user:positioned');
    },this));
  },

  setCenter: function(lat, lon, zoom) {
    !zoom && zoom !== 0 && (zoom = this.map.getZoom());
    this.map.setView(Leaflet.latLng(lat,lon), zoom);
  },

  trySetCoordsByIp: function(){
    var deferred = $.Deferred();

    var ajaxParams = {
      url: bookedby.routes.BOOKING.GET_GEO_IP,
      method: 'GET',
      cache: true,
    };

    var success = _.bind(function(data) {
      if (data.success && data.lat && data.lon) {
        this.setCenter(data.lat, data.lon);
        deferred.resolve();
      } else {
        deferred.reject();
      }
    }, this);

    var error =function() {
      deferred.reject();
    };

    requestsManager.newRequest(requestsManagerKeys.GET_GEO_IP, ajaxParams, true)
      .then(success, error);

    return deferred;
  },

  setUserPosition: function(latitude, longitude) {

    var myLatLng = Leaflet.latLng(latitude, longitude);

    if (this.userPosition == null) {
      var marker = Leaflet.marker(myLatLng, {
        title: 'You'
      });
      this.userPosition = {
        latitude: latitude,
        longitude: longitude,
        marker: marker
      };
      marker.addTo(this.map);
    } else {
      this.userPosition.latitude = latitude;
      this.userPosition.longitude = longitude;
      this.userPosition.marker.setLatLng(myLatLng);
    }
  },

  recomputeZoom: function(stores) {

    var bounds = Leaflet.latLngBounds();
    bounds.extend(this.map.getCenter());
    _.each(stores, function(store) {
      bounds.extend(Leaflet.latLng(store.latitude, store.longitude));
    });

    this.map.fitBounds(bounds);
  },

  unsetCoordinatesAndUserPosition: function() {
    if (this.userPosition && this.userPosition.marker)
      this.map.removeLayer(this.userPosition.marker);

    this.userPosition = null;

    _.each(this.storesMap, function(store) {
      if (store)
        delete store.userDistance;
    });

    this.reloadMarkers();
  },

  setCoordinatesAndUserPosition: function(lat, lon) {
    this.resetStoreSelection();

    this.shouldRecomputeNextZoom = true;
    this.setCenter(lat, lon, this.defaultZoom);
    this.setUserPosition(lat,lon);

    var removedDistancesStoresMap = {};
    _.each(this.storesMap, function(store, index) {
      if (!store) return;

      delete store.userDistance;
      removedDistancesStoresMap[index] = store;
    });
    this.storesMap = removedDistancesStoresMap;
  },

  parseStatus: function(store) {
    switch(store.status) {
      case 'open':
        return 'Open';
      case 'wait-too-long':
      case 'unavailable':
        return {
          'class': 'unavailable',
          'title': 'Info'
        };

      case 'not-available-for-today':
        return {
          'class': 'not-available-for-today',
          'title': 'Not Available For Today'
        };

      default:
        return {
          'class': 'closed',
          'title': 'Closed'
        }
    }
  },

  getMarkerHTML: function(store, employeeWaitTime) {
    var waitTime = employeeWaitTime == null ? store.estimatedWaitTime : employeeWaitTime;

    var markerContent = '<div class="salon-wait-time-marker-container clickable-area">';

    var isSelected = store.isSelected || this.selectedStoreId == store.id || this.selectedStoreId == store.shortName;

    markerContent += '<div class="salon-wait-time-marker in-map ' + (isSelected ? 'is-selected' : (store.status == 'open' ? 'is-unselected' : 'is-closed' )) +'">';

    if (store.userDistance != null && store.status == 'open') {
      markerContent += '<div class="user-distance">' + store.userDistance + '</div>'
    }

    if (typeof store.status === 'undefined') {
      if (!_.isEmpty(store.schedule) && store.schedule.from < store.currentTime &&
        store.schedule.to > store.currentTime) {
        store.status = 'unavailable';
      } else {
        store.status = 'closed';
      }
    }

    if (store.status == 'open') {
      waitTime =  bookedby.helpers.secondsToMinutesRoundable(waitTime, 1);
      markerContent += '<div class="salon-wait-time-marker-content"><div>Wait</div>' +
        '<div class="duration-container">' + waitTime + '</div><div>min</div>' +
        '<span class="visuallyHidden">Location '+ store.addressLine1 + ', ' + store.addressLine2 +'</span>'+
          '<span  class="visuallyHidden">Wait Time is ' + waitTime + ' Minutes at ' + store.addressLine1 + ', ' + store.addressLine2 +' location</span>'+
          '</div>';
    } else if (store.status === 'wait-too-long') {
      var statusInfo = this.parseStatus(store);
      markerContent += '<div class="salon-wait-time-marker-content ' + statusInfo.class + '">' +
      statusInfo.title + '<span class="visuallyHidden">Location '+ store.addressLine1 + ', ' + store.addressLine2 + '</span>'+
          '</div>'
    } else if (store.status === 'not-available-for-today') {
      var closeTime =  bookedby.helpers.timeFormatMarker(store.schedule.to);
      markerContent += '<div class="salon-wait-time-marker-content"><div class="salon-wait-time-marker-content-opens-text">Closes</div>' +
        '<div class="open-time-container">' + closeTime + '</div><span class="visuallyHidden">Location '+ store.addressLine1 + ', ' + store.addressLine2 + '</span>'+'</div>';
    } else {
      var statusInfo = this.parseStatus(store);

      if (statusInfo.class === 'closed' && store.schedule &&
        (store.currentTime || store.currentTime === 0) && store.schedule.from > store.currentTime) {

        var openTime =  bookedby.helpers.timeFormatMarker(store.schedule.from);
        markerContent += '<div class="salon-wait-time-marker-content"><div class="salon-wait-time-marker-content-opens-text">Opens</div>' +
          '<div class="open-time-container">' + openTime + '</div><span class="visuallyHidden">Location '+ store.addressLine1 + ', ' + store.addressLine2 +'</span>'+'</div>';
      } else if (statusInfo.class === 'closed' && store.schedule &&
        store.schedule.to && store.schedule.from && store.nextDaySchedule &&
        store.nextDaySchedule.from && store.nextDaySchedule.to &&
        (store.currentTime || store.currentTime === 0) && store.schedule.to <= store.currentTime) {

        var openNextDayTime =  bookedby.helpers.timeFormatMarker(store.nextDaySchedule.from);
        markerContent += '<div class="salon-wait-time-marker-content"><div class="salon-wait-time-marker-content-opens-text">Opens</div>' +
          '<div class="open-time-container">' + openNextDayTime + '</div><span class="visuallyHidden">Location '+ store.addressLine1 + ', ' + store.addressLine2 +'</span>'+'</div>';
      } else {
        markerContent += '<div class="salon-wait-time-marker-content ' + statusInfo.class + '">' +
        statusInfo.title + '<span class="visuallyHidden">Location '+ store.addressLine1 + ', ' + store.addressLine2 + '</span>'+'</div>'
      }
    }
    markerContent += '</div></div>';

    return markerContent;
  },

  setGuestsWaitingTimes: function(checkInData) {

    var getServiceString = function(serivce, provider){
      return '' + serivce + (provider? '-' + provider : '');
    }

    var serviceStrings = [];

    var asGuest = checkInData.iAmOnlyCheckingInAGuest;

    if (checkInData && checkInData.guests && checkInData.guests.length){
      if (asGuest) {
        checkInData.guests[0].recentEstimative = checkInData.recentEstimative;
      }
      for (var i=(asGuest?1:0); i<checkInData.guests.length; i++){
        serviceStrings.push(getServiceString(checkInData.guests[i].service, checkInData.guests[i].employee));
      }
    }

    var ajaxObject = {
      url: bookedby.routes.BOOKING.WAIT_LIST_SEARCH,
      contentType: 'application/json',
      data: {
        store: checkInData.store,
        services: asGuest?
          getServiceString(checkInData.guests[0].service, checkInData.guests[0].employee)
          : getServiceString(checkInData.services[0].service, checkInData.services[0].employee),
        searchServiceIdx: 1,
        firstAvailable: '0',
        guestServices: serviceStrings.join('_'),
        storeGroupUuid: bookedby.staticData.storeGroupId
      },
      method: 'GET',
      cache: false
    };

    return requestsManager.newRequest(requestsManagerKeys.WAIT_LIST_SEARCH, ajaxObject, true).then(
      function(data) {
        if (data.success && data.searchResults && data.searchResults.guestResults && data.searchResults.guestResults.length){
          var results = asGuest?
            [data.searchResults.results].concat(data.searchResults.guestResults) :
            data.searchResults.guestResults;
          var selectedEmployees = asGuest?
            [data.searchResults.mainClientEmployee].concat(data.searchResults.guestResultsEmployees) :
            data.searchResults.guestResultsEmployees;
          for (var i=0; i< results.length; i++){
            var requestedEmpId = selectedEmployees[i];
            for (var j = 0; j < results[i].length; j++){
              if (results[i][j].employeeId = requestedEmpId){
                checkInData.guests[i].recentEstimative = results[i][j].waitTime;
              }
            }
          }
          return {success: true};
        } else {
          return {success: false, error: data.error};
        }
      });
  },

  resetStoreSelection: function() {
    if (this.selectedStoreId != null) {
      this.model.set('iAmOnlyCheckingInAGuest', false);
      var marker = this.markersMap[this.selectedStoreId];
      var store =  this.storesMap[this.selectedStoreId];
      this.selectedStoreId = null;

      if (store) store.isSelected = false;

      if (store && marker)
        this.updateMarker(store.id);

      if (marker){
        marker.setZIndexOffset(this.MAX_Z_INDEX);
      }

      this.closeDialogForStore();
      //Drop url of selected store
      if (bookedby.app.currentData.storeId) delete bookedby.app.currentData['storeId'];
      if (bookedby.app.currentData.store) delete bookedby.app.currentData['store'];
      bookedby.app.navigateWithReplace(bookedby.app.currentPath, bookedby.app.currentData);
    }
  },

  /**
   * Selects a store by its ID and centers the map on it. Arrays storesMap and markersMap work as a cache and are checked
   * before it uses the bookedby.routes.SEARCH.GET_STORE_LOCATION API endpoint to search for a store.
   * If the store is found, it centers the map on the respective marker (or created one if doesn't exist yet).
   */
  selectStoreById: function(storeId) {
    this.model.set('iAmOnlyCheckingInAGuest', false);
    var deferred = $.Deferred();
    var store = this.storesMap[storeId];
    if (!store) {
      store = _.find(this.storesMap, function(x) {
        return x && x.shortName === storeId;
      });
    }

    var marker = store ? this.markersMap[store.id] : null;
    if (!store || !marker){
      var ajaxParams = {
        url: bookedby.routes.SEARCH.GET_STORE_LOCATION,
        contentType: 'application/json',
        data: {
          store: storeId
        },
        method: 'GET',
        cache: true,
      };

      var success = _.bind(function(data) {
        if (data.success) {
          if (data && data.location && data.location.coordinates){
            this.setCenter(data.location.coordinates[1],data.location.coordinates[0]);
            this.loadCloseStores().then(_.bind(function(){
              store = this.storesMap[storeId];
              if (!store) {
                store = _.find(this.storesMap, function(x) {
                  return x && x.shortName === storeId;
                });
              }
              // this marker should really be found!!!
              marker = this.markersMap[store.id];
              if (!marker) {
                this.createMarker(store);
              }
              this.selectStore(store);
              deferred.resolve();
            },this));
          } else {
            deferred.resolve();
          }
        } else {
          deferred.reject();
        }
      }, this);

      var error = function() {
        deferred.reject();
      };

      requestsManager.newRequest(requestsManagerKeys.GET_STORE_LOCATION, ajaxParams, true)
        .then(success, error);

    } else {
      this.selectStore(store);
      deferred.resolve();
    }
    return deferred;
  },

  updateScheduleForSelectedStore: function(stores, store) {
    if (!stores || !store) return;

    var newStoreInfo = _.find(stores, {id: store.id});
    newStoreInfo && (store.schedule = newStoreInfo.schedule);

    this.model.set('schedule', store.schedule);
  },
  /**
   * Used to update the selected's store marker (and set it as the map center) and open its dialog.
   */
  selectStore: function(store) {
    var storeId = +store.id;
    var marker = null;

    if (this.selectedStoreId != null) {
      var prevMarker = this.markersMap[this.selectedStoreId];
      var prevStore = this.storesMap[this.selectedStoreId];
      if (prevStore) prevStore.isSelected = false;
      this.selectedStoreId = null;
      if (prevMarker && prevStore) this.updateMarker(prevStore.id);
      if (prevMarker)
        prevMarker.setZIndexOffset(this.MAX_Z_INDEX);
    }
    marker = this.markersMap[storeId];

    this.storesMap[storeId].isSelected = true;
    this.storesMap[storeId].isVisible = true;
    this.updateMarker(storeId);

    this.openDialogForStore(storeId);
    this.selectedStoreId = storeId;

    if (marker)
      marker.setZIndexOffset(this.MAX_Z_INDEX + 1);

    this.setCenter(store.latitude, store.longitude);
  },

  addStores: function(stores, recomputeZoom) {

    var deferred = $.Deferred();

    _.each(this.storesMap, _.bind(function(store) {
      if (store) {
        store.isVisible = false;
        store.isSelected = this.selectedStoreId == store.id;
      }
    }, this));

    var newStores = [];
    _.each(stores, _.bind(function(store) {
      if (!store) return;

      store.isVisible = true;
      if (this.storesMap[store.id] == null) {
        this.storesMap[store.id] = store;
        newStores.push(store.id);
      } else {
        this.storesMap[store.id].isVisible = true;

        //If a previously-existing store had it's last wait time update longer than the standard refresh period, add it to the list of stores to load wait times for
        if (this.storesMap[store.id].waitTimeUpdatedUtc == null || moment.utc().diff(this.storesMap[store.id].waitTimeUpdatedUtc) > this.UPDATE_WAIT_TIMES_COOLDOWN) {
          newStores.push(store.id);
        }
      }

    }, this));

    if (newStores.length > 0) {
      deferred = this.partialLoadStoresWaitTimes(newStores);
    } else {
      deferred.resolve();
    }

    if (recomputeZoom) {
      this.recomputeZoom(stores);
    }
    return deferred;
  },

  getUpdatedStoreWaitTimes: function() {
    if (this.disposeWaitTimesTimeout) {
      return;
    }

    var visibleStores = _.pluck(_(this.storesMap).filter(function(store) {
      return store && store.isVisible == true;
    }), 'id');

    if (visibleStores.length > 0) {
      this.ignoreUpdateShownMarker = false;
      this.loadStoresWaitTimes(visibleStores);
    }

    this.currentWaitTimesTimeout = setTimeout(_.bind(this.getUpdatedStoreWaitTimes, this), this.UPDATE_WAIT_TIMES_COOLDOWN);

  },

  addStoreMarkers: function(stores) {
    _.each(stores, _.bind(function(store) {
      var storeInfo = _.extend(this.storesMap[store.id], store);

      if (!storeInfo) return;

      this.storesMap[store.id] = storeInfo;
      if (this.markersMap[store.id] == null) {
        this.createMarker(storeInfo);
      } else {
        this.updateMarker(store.id);
      }
    }, this));
  },

  createMarker: function(store) {
    if (!store) {
      return;
    }

    var markerContent = this.getMarkerHTML(store);

    var position = Leaflet.latLng(store.latitude, store.longitude);
    var icon = Leaflet.divIcon({className: 'marker-icon', html: markerContent});

    var marker = Leaflet.marker(position, {icon: icon});
    marker.addTo(this.map);

    marker.on('click', _.bind(function() {
      //Changing url and causing all the underlying selection logig through setData in start-wail-list.js
      bookedby.app.currentData.store = store.id;
      //Remove auto-added "quickfixed" param from abstract-app.js store default parameter handling on stateChange
      if (bookedby.app.currentData.storeId) delete bookedby.app.currentData['storeId'];
      bookedby.app.navigateWithReplace(bookedby.app.currentPath, bookedby.app.currentData);

      // Google Analytics event
      global.bookedby.helpers.pinClickEvent(store.name);
    }, this));

    this.markersMap[store.id] = marker;

    $(".marker-icon").attr("role", "link");
  },

  updateMarker: function(storeId, employeeWaitTime) {

    var store = this.storesMap[storeId];
    var marker = this.markersMap[storeId];

    if (!marker || !store) {
      return;
    }

    var position = Leaflet.latLng(store.latitude, store.longitude);
    var markerContent = this.getMarkerHTML(store, employeeWaitTime);
    var icon = Leaflet.divIcon({className: 'marker-icon', html: markerContent});
    marker.setIcon(icon);
    marker.setLatLng(position);

    if (this.selectedStoreId === storeId && !this.ignoreUpdateShownMarker) {
      var storeInfo = this.storesMap[storeId];
      this.model.set('estimatedTime', storeInfo.estimatedWaitTime);
      this.loadEmployeesWaitTimes();
    }

    $(".marker-icon").attr("role", "link");
  },

  reloadMarkers: function() {
    var self = this;
    _.each(this.storesMap, function(store) {
      if (store && !store.isSelected) {
        self.updateMarker(store.id);
      }
    })
  },

  closeDialogForStore: function() {
    checkinLaterState.setUseCheckinLater(false);

    this.model.set('showStoreModal', false);
    this.model.set('storeName', '');
    this.model.set('selectedStore', -1);
    this.model.set('storeAddressLine1', '');
    this.model.set('storeAddressLine2', '');
    this.model.set('storeEmail', '');
    this.model.set('storePhone', '');
    this.model.set('storeRating', 0);
    this.model.set('storeReviewsCount', 0);
    this.model.set('estimatedTime', null);
    this.model.set('hasAvailability', false);
    this.model.set('isFullyLoaded', true);

    this.model.set('statusClass', '');
    this.model.set('statusTitle', '');
    this.model.set('statusMessage', '');

    this.model.set('provider', null);

    this.trigger('storeChanged');
  },

  openDialogForStore: function(storeId) {

    var storeInfo = this.storesMap[storeId];
    if (!storeInfo || !storeInfo.status) return;

    bookedby.app.noteSelectedStore(storeInfo);
    checkinLaterState.setUseCheckinLater(storeInfo.storeSettings.useCheckinLater);

    this.model.set('storeName', storeInfo.name);
    this.model.set('selectedStore', storeId);
    this.model.set('storeAddressLine1', storeInfo.addressLine1);
    this.model.set('storeAddressLine2', storeInfo.addressLine2);
    this.model.set('storeEmail', storeInfo.email);
    this.model.set('storePhone', storeInfo.phone);
    this.model.set('storeRating', storeInfo.rating);
    this.model.set('storeReviewsCount', storeInfo.numReviews != null ? storeInfo.numReviews : 0);

    this.model.set('hasAvailability', storeInfo.estimatedWaitTime != null);

    this.model.set('estimatedTime', storeInfo.estimatedWaitTime);
    this.model.set('schedule', storeInfo.schedule);
    this.model.set('nextDaySchedule', storeInfo.nextDaySchedule);
    this.model.set('currentTime', storeInfo.currentTime);
    this.model.set('isFullyLoaded', false);

    var statusInfo = this.parseStatus(storeInfo);

    if (storeInfo.status !== 'wait-too-long') {
      this.model.set('statusClass', statusInfo.class);
      this.model.set('statusTitle', statusInfo.title);
    }

    this.model.set('statusMessage', storeInfo.statusDetails);

    this.model.set('provider', null);

    this.clientInfoComponent.model.set('validationSuspended', true);
    this.model.get('guests').resetGuestsValidation();
    this.model.get('guests').set('numberOfGuests', 0);

    bookedby.app.scheduleManager.setNewStore(storeId);

    this.getEmployees(storeId);

    if (this.model.get('hasAvailability'))
      this.clientInfoComponent.setFocus();

    this.model.set('showStoreModal', true);

    this.trigger('storeChanged');
  },

  /**
   * Gets employee information for the currently selected store
   */
  getEmployees: function(storeId) {

    var ajaxParams = {
      url: bookedby.routes.BOOKING.GET_SERVICE_PROVIDERS,
      contentType: 'application/json',
      data: {
        storeId: storeId,
        storeGroupUuid: window.bookedby.staticData.storeGroupId
      },
      method: 'GET',
      dataType: 'jsonp'
    };

    var success = _.bind(function(data) {
      bookedby.app.serviceManager.bindServiceDetails(data);
      this.model.get('guests').set('storeId', storeId); // reload employees and services map after ajax call
      this.trigger('employeesLoaded', storeId);
    }, this);

    var error = function(jqXHR, textStatus, textError) {
      console.log('Error: ' + textError);
    };

    requestsManager.newRequest(requestsManagerKeys.GET_SERVICE_PROVIDERS, ajaxParams, true)
      .then(success, error);
  },

  getVisibleRadius: function() {

    var center = this.map.getCenter();
    var bounds = this.map.getBounds();
    if (bounds != null) {
      var ne = bounds.getNorthEast();
      var radiusMeters = geolib.getDistance({
        latitude: center.lat,
        longitude: center.lng
      }, {
        latitude: ne.lat,
        longitude: ne.lng
      });

      return Math.floor(radiusMeters);
    }
    return 0;
  },

  loadCloseStores: function(recomputeZoom) {

    recomputeZoom = recomputeZoom === true;

    var center = this.map.getCenter();
    var lat = center.lat;
    var lon = center.lng;

    var radius = this.getVisibleRadius();

    var deferred = $.Deferred();

    var ajaxParams = {
      url: bookedby.routes.SEARCH.SEARCH_NEAREST_OPEN_STORES,
      contentType: 'application/json',
      data: {
        storeGroupUuid: bookedby.staticData.storeGroupId,
        latitude: lat,
        longitude: lon,
        radius: radius,
        date: moment().format('YYYY-MM-DD')
      },
      method: 'GET',
      cache: false,
    };

    var success = _.bind(function(data) {
      if (data.success) {

        if (data.stores.length == 0) {
          deferred.resolve();
        } else {
          if (this.selectedStoreId !== null) {
            this.updateScheduleForSelectedStore(data.stores, this.storesMap[this.selectedStoreId])
          }
          this.addStores(data.stores, recomputeZoom).then(function(){
            deferred.resolve();
          });
        }
      } else {
        deferred.reject();
      }
    }, this);

    var error = function() {
      deferred.reject();
    };

    requestsManager.newRequest(requestsManagerKeys.SEARCH_NEAREST_OPEN_STORES, ajaxParams, true)
      .then(success, error);

    return deferred;
  },

  /**
   * Finds wait times for all the given stores in the same request
   * @param {array} storeIds
   */
  loadStoresWaitTimes: function(storeIds) {

    var storesString = _.reduce(storeIds, function(memo, store) {
      if (memo.length > 0) {
        memo += ',';
      }
      return memo + store;
    }, '');

    var ajaxObject = {
      url: bookedby.routes.SEARCH.GET_STORE_WAIT_TIMES,
      contentType: 'application/json',
      data: {
        storeGroupUuid: bookedby.staticData.storeGroupId,
        stores: storesString
      },
      method: 'GET',
      cache: false,
    };

    var success = _.bind(function(data) {
      if (data.success) {
        _.each(data.stores, function(store) { store.waitTimeUpdatedUtc = moment.utc(); });
        this.addStoreMarkers(data.stores);
      }
    }, this);

    requestsManager.newRequest(requestsManagerKeys.GET_STORE_WAIT_TIMES + storesString, ajaxObject, true).then(success);
  },

  /**
   * Finds wait times for all the given stores in multiple requests
   * @param {array} storeIds
   * @param {boolean} recomputeZoom it should recompute the zoom to only show this stores
   */
  partialLoadStoresWaitTimes: function(storeIds, recomputeZoom) {

    var _getStoreWaitTimes = _.bind(function(index) {

      var deferred = $.Deferred();

      if (index >= storeIds.length) {
        deferred.resolve();
        return deferred;
      }

      var batchStoreIds = storeIds.slice(index, index + this.STORE_PER_BATCH);
      var storesString = _.reduce(batchStoreIds, function(memo, store) {
        if (memo.length > 0) {
          memo += ',';
        }
        return memo + store;
      }, '');

      var ajaxObject = {
        url: bookedby.routes.SEARCH.GET_STORE_WAIT_TIMES,
        contentType: 'application/json',
        data: {
          storeGroupUuid: bookedby.staticData.storeGroupId,
          stores: storesString
        },
        method: 'GET',
        cache: false,
        timeout: 5000
      };

      var success = _.bind(function(data) {
        if (data.success) {
          _.each(data.stores, function(store) { store.waitTimeUpdatedUtc = moment.utc(); });
          this.addStoreMarkers(data.stores, recomputeZoom);
          _getStoreWaitTimes(index + this.STORE_PER_BATCH);
        }
        deferred.resolve();
      }, this);

      var error = _.bind(function(){
        this.addStoreMarkers(_.filter(this.storesMap, function(store) {
          return storeIds.indexOf(store.id) !== -1 }),
          recomputeZoom);
        deferred.reject();
      }, this);

      requestsManager.newRequest(requestsManagerKeys.GET_STORE_WAIT_TIMES + storesString, ajaxObject, true)
        .then(success, error);

      return deferred;
    }, this);

    return _getStoreWaitTimes(0);
  },

  checkLoadCloseStores: function() {

    this.centerPositionVersion++;
    var _centerVersion = this.centerPositionVersion;
    setTimeout(_.bind(function() {
      if (_centerVersion == this.centerPositionVersion) {

        var recomputeZoom = this.shouldRecomputeNextZoom;
        this.shouldRecomputeNextZoom = false;
        this.loadCloseStores(recomputeZoom);
      }
    }, this), 500);

  },

  getWaitListRequestData: function() {
    var serviceString = '' + this.model.get('service').get('id') +
      (this.model.get('provider') != null ? '-' + this.model.get('provider').get('id') : '');

    if (bookedby.staticData.storeGroupSettings.allowMultipleGuestBooking) {
      if (this.model.get('iAmOnlyCheckingInAGuest')) {
        return {
          store: this.model.get('selectedStore'),
          services: this.model.get('guests').computeFirstGuestSearch(),
          searchServiceIdx: 1,
          firstAvailable: '0',
          guestServices: this.model.get('guests').computeRestGuestSearch().join('_'),
          storeGroupUuid: bookedby.staticData.storeGroupId
        }
      } else {
        return {
          store: this.model.get('selectedStore'),
          services: serviceString,
          searchServiceIdx: 1,
          firstAvailable: '0',
          guestServices: this.model.get('guests').computeGuestSearch().join('_'),
          storeGroupUuid: bookedby.staticData.storeGroupId
        }
      }
    } else {
      return {
        store: this.model.get('selectedStore'),
        services: serviceString,
        firstAvailable: '0',
        storeGroupUuid: bookedby.staticData.storeGroupId
      }
    }
  },

  /**
   * Uses bookedby.routes.BOOKING.WAIT_LIST_SEARCH API endpoint to find the individual
   * employee wait times for the selected store.
   * If the result of that same endpoint is empty, the store is considered unavailable.
   */
  loadEmployeesWaitTimes: function() {
    var params = this.getWaitListRequestData();

    if (!params.store || params.store == -1) {
      return;
    }

    this.loadAvailableTimeSlots(params);

    var ajaxObject = {
      url: bookedby.routes.BOOKING.WAIT_LIST_SEARCH,
      contentType: 'application/json',
      data: params,
      method: 'GET',
      cache: false
    };

    var success = _.bind(function(data) {
      if(data.success) {
        this.ignoreUpdateShownMarker = true;
        if (!_.isEmpty(data.searchResults.results)) {
          bookedby.app.serviceManager.bindEmployeeWaitTimes(data.searchResults.results);

          if (bookedby.staticData.storeGroupSettings.allowMultipleGuestBooking) {
            if (this.model.get('iAmOnlyCheckingInAGuest')) {
              var results = [data.searchResults.results].concat(data.searchResults.guestResults)
              bookedby.app.serviceManager.bindGuestWaitTimes(results);
            } else {
              bookedby.app.serviceManager.bindGuestWaitTimes(data.searchResults.guestResults);
            }

            this.model.get('guests').reCheckGuestsServiceProviders();
            this.reCheckMarkerWaitTime(this.model.get('selectedStore'));
          }
        } else {
          //TODO review
          this.model.set('noAvailabilityOnWait', true);
          this.model.set('noAvailabilityOnWaitReason', data.searchResults.reason);
          this.model.set('hasAvailability', false);
          this.model.set('statusMessage', data.searchResults.reason);

          var store = this.storesMap[params.store];
          if (store) {
            store.status = data.searchResults.status;
            store.statusDetails = data.searchResults.reason;
            store.estimatedWaitTime = data.searchResults.estimatedWaitTime || null;
            var statusInfo = this.parseStatus(store);

            this.model.set('statusClass', statusInfo.class);
            this.model.set('statusTitle', statusInfo.title);

            this.updateMarker(params.store);
          }
        }

        this.model.set('isFullyLoaded', true);
      }
    }, this);

    requestsManager.newRequest(requestsManagerKeys.WAIT_LIST_SEARCH, ajaxObject, true).then(success);
  },

  loadAvailableTimeSlots: function(params) {
    if (!checkinLaterState.getUseCheckinLater()) {
      return;
    }

    var ajaxObject = {
      url: bookedby.routes.BOOKING.CHECK_IN_LATER_TIMESPANS,
      contentType: 'application/json',
      data: JSON.stringify({
        store: params.store,
        storeGroupUuid: params.storeGroupUuid
      }),
      method: 'POST',
      dataType: 'json',
      cache: false
    };

    var success = _.bind(function(data) {
      if (data.success) {
        this.model.set(
          "availableSlots",
          data.value.availableTimeStamps.map(function (it) {
            return {
              value: it,
              label: moment().clone().startOf("day").add(it, "seconds").format("h:mm A"),
            };
          })
        );
      }
    }, this);

    requestsManager.newRequest("availableSlots", ajaxObject, true).then(success);
  },

  reCheckMarkerWaitTime: function(storeId) {
    if (storeId == -1) {
      return;
    }

    var minWaitTime = _.min(_.map(bookedby.app.serviceManager.employeeWaitTimesMap, function(x) { return x.waitTime; }));
    if (this.model.get('provider') != null && bookedby.app.serviceManager && bookedby.app.serviceManager.employeeWaitTimesMap) {
      var providerInEmployeeWaitTimeMap = bookedby.app.serviceManager.employeeWaitTimesMap[this.model.get('provider').get('id')];
      minWaitTime = providerInEmployeeWaitTimeMap ? providerInEmployeeWaitTimeMap.waitTime : minWaitTime;
    }

    this.model.set('estimatedTime', minWaitTime);
    this.model.set('hasAvailability', minWaitTime !== null);

    var store = this.storesMap[storeId];
    if (store) {
      store.estimatedWaitTime = minWaitTime;
      store.status = 'open';
      store.statusDetails = '';
    }

    this.updateMarker(storeId);
  },

  employeeChanged: function() {
    var employee = this.model;

    if (this.model.get('selectedStore') == -1)
      return;

    var newEstimatedTime = employee.get('provider') != null ?
      bookedby.app.serviceManager.employeeWaitTimesMap[employee.get('provider').get('id')].waitTime :
      this.storesMap[this.model.get('selectedStore')].estimatedWaitTime;

    this.model.set('estimatedTime', newEstimatedTime);
    this.updateMarker(this.model.get('selectedStore'), newEstimatedTime);
  },

  initEvents: function() {
    this.map.on('moveend', _.bind(function() {
      locationService.updateCachedLocation(this.map.getCenter());
    }, this));

    this.map.on('dragend', _.bind(function() {
      this.checkLoadCloseStores();
    }, this));

    this.map.on('viewreset', _.bind(function() {
      this.checkLoadCloseStores();
    }, this));

    this.map.on('zoomend', _.bind(function() {
      if (!this.recomputeZoomAfterChangeLocation) {
        this.shouldRecomputeNextZoom = false;
      }

      this.recomputeZoomAfterChangeLocation = false;
      this.checkLoadCloseStores();
    }, this));

    this.map.on('click', _.bind(function() {
      this.resetStoreSelection();

    }, this));

    this.on('employeesLoaded', this.loadEmployeesWaitTimes, this);

    this.listenTo(this.model.get('guests'), 'change:numberOfGuests', _.bind(this.guestsNumberChanged, this));
    this.listenTo(this.model.get('guests'), 'guests:changed', _.bind(this.guestProviderChanged, this));

    this.listenTo(this.model, 'change:provider', _.bind(this.guestProviderChanged, this));

    this.model.on('change:provider', this.employeeChanged, this);

    $(window).resize(_.bind(function() {
      this.fixMapHeight();
    }, this));

    this.listenTo(this, 'storeChanged', function() {
      this.fixMapHeight();
    });

    this.guestsComponent.on('finishRender', function() {
      this.fixMapHeight();
    }, this);

    this.listenTo(this.clientInfoComponent, 'renderingForm', function() {
      this.fixMapHeight();
    });
  },

  guestsNumberChanged: function(model) {
    this.employeeChanged();
    if (model.get('numberOfGuests') === 0) {
      this.model.set('iAmOnlyCheckingInAGuest', false);
    }
    this.loadEmployeesWaitTimes();
  },

  updateGuestHash: function() {
    this.model.set(
      "guestsHash",
      JSON.stringify(
        this.model
          .get("guests")
          .get("serviceProviders")
          .map(function (guest) {
            return { employee: guest.get("provider") ? guest.get("provider").id : null };
          }),
      ),
    );
  },

  guestProviderChanged: function() {
    this.employeeChanged();
    this.loadEmployeesWaitTimes();
    this.updateGuestHash();
  },

  removeEvents: function() {
    //TODO implement
    this.map.remove();

    this.stopListening();
  },

  fixMapHeight: function() {
    var topBarHeight = $('.top-bar').height();
    var optionsHeight = $('#optionsSelector').outerHeight() + 20 + 10;
    var height = $(window).height() - topBarHeight - optionsHeight;

    $('#storeModal').css('max-height', height - 12);
    $('#mapContainer').css('height', ((height + optionsHeight) - 2));

    var storeInfoHeight = $('.store-info-container').outerHeight() + 10;

    $('#appointmentModal').css('max-height', height - storeInfoHeight - 15);
  },

  beforeRender: function() {
    this.setView('.select-employee-area', this.employeeComponent);
    this.setView('.client-form-area', this.clientInfoComponent);
    this.setView('.select-guest-provider-area', this.guestsComponent);

    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  afterRender: function() {
    this.applyBindings();
    this.fixMapHeight();
    this.initMap();
    this.initEvents();
    if (bookedby.staticData.regError){
      bookedby.app.confirmForm.show(_.noop, _.noop, {
        title: 'Registration error',
        message: bookedby.staticData.regError,
        confirmLabel: 'Ok',
        showCancelLabel: false,
        allowClose: false
      });
      bookedby.staticData.regError = null;
    } else if (bookedby.staticData.regCode){
      this.registationCodeEmmited(bookedby.staticData.regCode, bookedby.staticData.hasCheckin);
    }
  },

  cleanup: function() {
    this.unsetCoordinatesAndUserPosition();
    this.resetStoreSelection();
    this.recomputeZoomAfterChangeLocation = false;
    this.markersMap = {};

    if (this.currentWaitTimesTimeout) {
      clearTimeout(this.currentWaitTimesTimeout);
    }
    this.disposeWaitTimesTimeout = true;

    this.removeEvents();
    this.removeBindings();
  }
});

module.exports = MapSelectorView;
